import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart4Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart4 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart4Config {
		return this.scenarioConfig.part4Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1ShowIndicatorUI();
	}

	public step1ShowIndicatorUI() {
		const context = this;

		context.scenario.addScore(context.scenario.cricMakeIncisionPoints);
		var onDoneWithPopup = context._scenario.doSomething('Making incision...');
		if(context.config.onMakingIncition) {
			context.config.onMakingIncition();
		}
		context.playVideoChapter(context.config.scalpelVideoChapter(), () => {
			
		});

		setTimeout(() => {
			onDoneWithPopup();
			context.step2ShowDecisionModal();
		}, constants.doSomethingTimeout);
	}

	public step2ShowDecisionModal() {
		const context = this;
		context.scenario.uiWrapper.displayScalpelUI({
			onKeepScalpelInPlaceClicked: () => {
				context.scenario.addScore(context.scenario.cricRemoveScalpelPoints);
				if(context.config.onKeepScalpelInPlaceClicked) {
					context.config.onKeepScalpelInPlaceClicked();
				}
				context.onDone();
			},
			onRemoveScalpelClicked: () => {
				context._scenario.cricRemoveScalpelPoints = 50;
				if(context.config.onRemoveScalpelClicked) {
					context.config.onRemoveScalpelClicked();
				}
				context._scenario.uiWrapper.displayNotificationUI({
					text: `<p class='notification-text'>Not a very smart idea...</p>`,
					onDismissed: () => {
					}
				})
			}
		})
	}
}